// We only want to allow a max of 3 products to be selected by the user
const TRY_IN_STORE_MAX_PRODUCTS = 3;

export { TRY_IN_STORE_MAX_PRODUCTS };
//# sourceMappingURL=storage.js.map
